import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReportState } from '../_reducers/report.reducers';

const getReportState = createFeatureSelector<ReportState>('report');

export const getReportsLoading = createSelector(
  getReportState,
  (state: ReportState) => state.reportsLoading
);

export const getMapSeriesFieldsLoading = createSelector(
  getReportState,
  (state: ReportState) => state.mapSeriesFieldsLoading
);

export const getReportFieldsLoading = createSelector(
  getReportState,
  (state: ReportState) => state.reportfieldsLoading
);

export const getFlexChartTypesLoading = createSelector(
  getReportState,
  (state: ReportState) => state.flexChartTypesLoading
);

export const getSummaryLoading = createSelector(
  getReportState,
  (state: ReportState) => state.summaryLoading
);

/**
 * Select reports
 */
export const getReports = createSelector(
  getReportState,
  (state: ReportState) => state.reports
);

/**
 * Select fields
 */
export const getReportFields = createSelector(
  getReportState,
  (state: ReportState) => state.fields
);

/**
 * Select fields
 */
export const getMapSeriesFields = createSelector(
  getReportState,
  (state: ReportState) => state?.seriesFields
);

/**
 * Select report
 */
export const getReportOperations = createSelector(
  getReportState,
  (state: ReportState) => state.operations
);

/**
 * Select report with filters
 */
export const getReportWFilters = createSelector(
  getReportState,
  (state: ReportState) => state.reportWithFilters
);

/**
 * Select datatable data
 */
export const getDatatable = createSelector(
  getReportState,
  (state: ReportState) => state.datatable
);

/**
 * Select report
 */
export const getFlexdata = createSelector(
  getReportState,
  (state: ReportState) => state.flexdata
);

export const getFlexdataRequest = createSelector(
  getReportState,
  (state: ReportState) => state.flexdataRequest
);

/**
 * Select flex boundary check
 */
export const getFlexBoundaryCheckResponse = createSelector(
  getReportState,
  (state: ReportState) => state.flexBoundaryCheckResponse
);

/**
 * Select summary report
 */
export const getSummary = createSelector(
  getReportState,
  (state: ReportState) => state.summary
);

/**
 * Select chart types
 */
export const getFlexChartTypes = createSelector(
  getReportState,
  (state: ReportState) => state.flexChartTypes
);

/**
 * Select chart types
 */
export const getReportDetails = createSelector(
  getReportState,
  (state: ReportState) => state.details
);

/**
 * Select columns
 */
export const getReportColumns = createSelector(
  getReportState,
  (state: ReportState) => state.columns
);

/**
 * Select calendar data
 */
export const getCalendarData = createSelector(
  getReportState,
  (state: ReportState) => state.calendarData
);

/**
 * Select map data
 */
export const getMapData = createSelector(
  getReportState,
  (state: ReportState) => state.mapData
);

/**
 * Select gantt data
 */
export const getGanttData = createSelector(
  getReportState,
  (state: ReportState) => state.ganttData
);

/**
 * Select error
 */
export const getTableError = createSelector(
  getReportState,
  (state: ReportState) => state.error
);

export const getFuzzyError = createSelector(
  getReportState,
  (state: ReportState) => state.fuzzyError
);

/**
 * Select train model data
 */
export const getTrainData = createSelector(
  getReportState,
  (state: ReportState) => state.trainData
);

/**
 * Select model result data
 */
export const getModelResultData = createSelector(
  getReportState,
  (state: ReportState) => state.modelResultData
);

/**
 * Select predict result data
 */
export const getPredictData = createSelector(
  getReportState,
  (state: ReportState) => state.predictData
);

/**
 * Select fuzzy match result data
 */
export const getFuzzyMatchData = createSelector(
  getReportState,
  (state: ReportState) => state.fuzzyData
);

export const getMessageData = createSelector(
  getReportState,
  (state: ReportState) => state.messageData
);

export const getChatError = createSelector(
  getReportState,
  (state: ReportState) => state.chatError
);


export const getPdfMessage = createSelector(
  getReportState,
  (state: ReportState) => state.pdfMessageData
);

export const getChatPdfError = createSelector(
  getReportState,
  (state: ReportState) => state.chatPdfError
);
